var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and allows selecting the door glazing type during the external damage declaration flow.
 * touches: declaration, externalDamage, doorDamage
 * invariants: The selected glazing type is synchronized with the DoorDamage model through v-model; available choices are defined by door glazing constants.
 * inputs: doorGlazingType, external damage state, DOOR_GLAZING_TYPE_CHOICES
 * outputs: updates doorGlazingType through v-model; displays validation errors associated with the doorGlazingType field.
 * see: @declaration/components/externalDamage/ExternalDamageComponent, @shared/constants/externalDamages/DoorConstants, @shared/types/api/externalDamage
 */
import { Component, VModel } from 'vue-property-decorator';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { DOOR_GLAZING_TYPE_CHOICES } from '@shared/constants/externalDamages/DoorConstants';
import { DOOR_GLAZING_TYPE_TITLE } from '@declaration/constants/externalDamages/DoorConstants';
let DoorGlazing = class DoorGlazing extends ExternalDamageComponent {
    get glazingChoices() {
        return DOOR_GLAZING_TYPE_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    get title() {
        return this.translateExternalDamageKey(DOOR_GLAZING_TYPE_TITLE);
    }
};
__decorate([
    VModel({ type: String, default: () => null })
], DoorGlazing.prototype, "doorGlazingType", void 0);
DoorGlazing = __decorate([
    Component({ components: { UiRadio, UiCard } })
], DoorGlazing);
export default DoorGlazing;
